import { updatePromoSetting } from 'api/editor';
import mergeAndRemoveKey from 'editor/utils/mergeAndRemoveKey';

const REPLACE_SETTING_THEME = 'REPLACE_SETTING_THEME';

const reducer = (state = {}, action = {}) => {
    switch (action.type) {
        case REPLACE_SETTING_THEME:
            return action.payload;
        default:
            return state;
    }
};

export default reducer;

export function updateSettingTheme(payload) {
    return async (dispatch, getState) => {
        const { settingTheme, promo, sponsor } = getState();
        await updatePromoSetting(sponsor.id, promo.id, { Themes: payload });

        dispatch({
            type: REPLACE_SETTING_THEME,
            payload: mergeAndRemoveKey(settingTheme, payload)
        });
    };
}
